// src/services/trustApi.js
import axios from "axios";
 
 
 
const getHeaders = (profile) => {
   
  const token = localStorage.getItem("idToken");
  const orgId = profile.orgId;
  const region =sessionStorage.getItem("userRegion") || "AP";
  return {
    "Content-Type": "application/json",
    "X-Region": region,
    "X-Org-Id": orgId,
    // ...(token && { Authorization: `Bearer ${token}` }),
  };
};
 
// ─── DOMAINS (from seeded compliance data) ───
// export const fetchAllDomainsApi = (profile, primaryOnly = true) =>
//   axios.get(`https://api.srqllabapi.com/trustdomainlist/api/trust/domains?primaryOnly=${primaryOnly}`, {
//     headers: getHeaders(profile),
//   });
  export const fetchAllDomainsApi = (profile, primaryOnly, selectedFrameworks = []) => {
  const params = {
    orgId: profile.orgId,
    primaryOnly,
  };
  if (selectedFrameworks.length > 0) {
    params.frameworks = selectedFrameworks.join(",");
  }
  return axios.get(`https://ndm4c2vvsl.execute-api.ap-southeast-2.amazonaws.com/prod/api/trust/domains`, {
    params,
    headers: getHeaders(profile),  // ✅ Added
  });
};

 
export const fetchDomainCoverageApi = (profile, domainId, primaryOnly = true) =>
  axios.get(
    `https://hgxtvrhh09.execute-api.ap-southeast-2.amazonaws.com/prod/api/trust/domain/${domainId}/coverage?primaryOnly=${primaryOnly}`,
    { headers: getHeaders(profile) }
  );
 
export const fetchDomainControlsApi = (profile, domainId, primaryOnly = true) =>
  axios.get(
    `https://jzlfh10d1j.execute-api.ap-southeast-2.amazonaws.com/prod/api/trust/domain/${domainId}/controls?primaryOnly=${primaryOnly}`,
    { headers: getHeaders(profile) }
  );
 
// ─── CONTROL — FULL 10-LAYER ARCHITECTURE ───
export const fetchControlFullApi = (profile, controlId, primaryOnly = true) =>
  axios.get(
    `https://xltajha3a8.execute-api.ap-southeast-2.amazonaws.com/prod/api/trust/control/${controlId}/full?primaryOnly=${primaryOnly}`,
    { headers: getHeaders(profile) }
  );
 
export const fetchControlApi = (profile, controlId) =>
  axios.get(`XYZ/trust/control/${controlId}`, {
    headers: getHeaders(profile),
  });
 
// ─── QUESTIONS (Assessment Layer) ───
export const saveQuestionResponseApi = (profile, controlId, questionId, payload) =>
  axios.put(
    `https://mklsjnrmok.execute-api.ap-southeast-2.amazonaws.com/prod/api/trust/control/${controlId}/question/${questionId}`,
    payload,
    { headers: getHeaders(profile) }
  );
 
// ─── POLICY MAPPING ───
export const addPolicyApi = (profile, controlId, payload) =>
  axios.post(`https://9p8glcfi75.execute-api.ap-southeast-2.amazonaws.com/prod/api/trust/control/${controlId}/policy`, payload, {
    headers: getHeaders(profile),
  });
 
export const removePolicyApi = (profile, controlId, policyId) =>
  axios.delete(
    `https://4pc7xord8g.execute-api.ap-southeast-2.amazonaws.com/prod/api/trust/control/${controlId}/policy/${policyId}`,
    { headers: getHeaders(profile) }
  );
 
// ─── EVIDENCE ───
export const addEvidenceApi = (profile, controlId, payload) =>
  axios.post(`https://s6x7pwd2fg.execute-api.ap-southeast-2.amazonaws.com/prod/api/trust/control/${controlId}/evidence`, payload, {
    headers: getHeaders(profile),
  });
 
export const removeEvidenceApi = (profile, controlId, evidenceId) =>
  axios.delete(
    `https://ro2wq59uxg.execute-api.ap-southeast-2.amazonaws.com/prod/api/trust/control/${controlId}/evidence/${evidenceId}`,
    { headers: getHeaders(profile) }
  );
 
// ─── OWNERSHIP ───
export const updateOwnershipApi = (profile, controlId, payload) =>
  axios.put(`https://s7s7w2z94h.execute-api.ap-southeast-2.amazonaws.com/prod/api/trust/control/${controlId}/ownership`, payload, {
    headers: getHeaders(profile),
  });
 
// ─── RISK MAPPING ───
export const addRiskMappingApi = (profile, controlId, payload) =>
  axios.post(
    `https://mtompfg3n0.execute-api.ap-southeast-2.amazonaws.com/prod/api/trust/control/${controlId}/risk-mapping`,
    payload,
    { headers: getHeaders(profile) }
  );
 
export const removeRiskMappingApi = (profile, controlId, riskId) =>
  axios.delete(
    `https://uwt2wek2wg.execute-api.ap-southeast-2.amazonaws.com/prod/api/trust/control/${controlId}/risk-mapping/${riskId}`,
    { headers: getHeaders(profile) }
  );
 
// ─── RISK TREATMENT ───
export const addRiskTreatmentApi = (profile, controlId, payload) =>
  axios.post(
    `https://px32isvn62.execute-api.ap-southeast-2.amazonaws.com/prod/api/trust/control/${controlId}/risk-treatment`,
    payload,
    { headers: getHeaders(profile) }
  );
 
export const removeRiskTreatmentApi = (profile, controlId, treatmentId) =>
  axios.delete(
    `https://rn7vptlxxh.execute-api.ap-southeast-2.amazonaws.com/prod/api/trust/control/${controlId}/risk-treatment/${treatmentId}`,
    { headers: getHeaders(profile) }
  );
 
// ─── RECOMMENDATIONS ───
export const addRecommendationApi = (profile, controlId, payload) =>
  axios.post(
    `https://i9a9v9jie2.execute-api.ap-southeast-2.amazonaws.com/prod/api/trust/control/${controlId}/recommendation`,
    payload,
    { headers: getHeaders(profile) }
  );
 
export const removeRecommendationApi = (profile, controlId, recId) =>
  axios.delete(
    `https://x0odrxq1ka.execute-api.ap-southeast-2.amazonaws.com/prod/api/trust/control/${controlId}/recommendation/${recId}`,
    { headers: getHeaders(profile) }
  );
 
// ─── SCORING ───
export const recalculateScoringApi = (profile, controlId, primaryOnly = true) =>
  axios.post(
    `https://9hel11b02g.execute-api.ap-southeast-2.amazonaws.com/prod/api/trust/control/${controlId}/recalculate?primaryOnly=${primaryOnly}`,
    {},
    { headers: getHeaders(profile) }
  );


  // ─── OVERVIEW ───
export const fetchOverviewApi = (profile) =>
  axios.get(`https://qq693tpbhf.execute-api.ap-southeast-2.amazonaws.com/prod/api/trust/overview`, {
    headers: getHeaders(profile),
  });

export const saveOverviewApi = (profile, payload) =>
  axios.put(`https://x3ewzrkqb2.execute-api.ap-southeast-2.amazonaws.com/prod/api/trust/update/overview`, payload, {
    headers: getHeaders(profile),
  });
  
export const fetchFrameworkListApi = (profile) => {
  return axios.get(`https://w3zo98vpz5.execute-api.ap-southeast-2.amazonaws.com/prod/api/trust/frameworks`, {
    params: { orgId: profile.orgId },
     headers: getHeaders(profile),
  });
};

// ─── READINESS ───
export const fetchReadinessApi = (profile, selectedFrameworks = []) => {
  const params = { orgId: profile.orgId, primaryOnly: true };
  if (selectedFrameworks.length > 0) {
    params.frameworks = selectedFrameworks.join(",");
  }
  return axios.get(`https://etw20t7cpl.execute-api.ap-southeast-2.amazonaws.com/prod/api/trust/readiness`, {
    params,
    headers: getHeaders(profile),
  });
};
